import React, { useState } from "react";
import { useDispatch } from "react-redux";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { saveArchiveWorkflow } from "actions/workflows";
import Input from "components/Elements/Input";

const ArchiveWorkflowModal = NiceModal.create(({ workflow = {} }) => {
  console.log("!!! workflow_id: ", workflow.public_id);
  const [title, setTitle] = useState("");
  const dispatch = useDispatch();
  const modal = useModal();

  const hide = (e) => {
    e.stopPropagation();
    modal.remove();
  };

  const save = () => {
    console.log("!!! SAVE ARCHIVE WORKFLOW: ", title);
    dispatch(saveArchiveWorkflow(workflow.public_id, title));
  };

  return (
    <>
      <div className="w-6/12 force-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-full my-6 mx-auto max-w-3xl">
          <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
            <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
              <h3 className="text-3xl font-semibold">
                Archive Workflow {workflow.name}{" "}
              </h3>
            </div>
            <div className="relative p-6 flex-auto ">
              <div className="my-4 text-blueGray-500 text-lg leading-relaxed">
                <div key="title" className="mb-4">
                  <label
                    className="block text-gray-700 text-sm font-bold mb-2"
                    htmlFor="title"
                  >
                    Title
                  </label>
                  <Input
                    type="text"
                    label="title"
                    name="title"
                    value={title}
                    onChange={(e) => {
                      setTitle(e.target.value);
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
              <button
                className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                type="button"
                onClick={hide}
              >
                Close
              </button>
              <button
                className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                type="button"
                onClick={() => save()}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
    </>
  );
});

export default ArchiveWorkflowModal;
